// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-27705B36-82E5-4D14-BB24-B12818BDBDB1 .tooltip button {\n  margin-top: 0!important;\n}\n", "",{"version":3,"sources":["webpack://src/security/macAddressManipulation/macAddressManipulation.less"],"names":[],"mappings":"AAEQ;EACI,uBAAA;AADZ","sourcesContent":["#V-27705B36-82E5-4D14-BB24-B12818BDBDB1{\n    & .tooltip{\n        & button{\n            margin-top: 0!important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
